

/**
 * PageContainer Component - Standardized page wrapper
 * 
 * @param {Object} props
 * @param {React.ReactNode} props.children - Page content
 * @param {string} props.className - Additional CSS classes
 * @param {Object} props.style - Additional inline styles
 * @param {boolean} props.hasFixedFooter - Whether page has fixed footer (adds bottom padding)
 */
function PageContainer({ 
  children, 
  className = 'container mt-3 mb-5',
  style = {},
  hasFixedFooter = false,
}) {
  const containerStyle = {
    ...style,
    ...(hasFixedFooter && { paddingBottom: '120px' }),
    transition: 'all 0.3s ease',
  }

  return (
    <div className={className} style={containerStyle}>
      {children}
    </div>
  )
}

export default PageContainer
